import { RouterReducerState } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  carSteps,
  flightSteps,
  hotelSteps,
  isCompleteMap,
} from '@shared/shared/components/travel-booking-progress-bar/data/travel-booking-progress-bar.data';
import { stepUrls } from '@shared/shared/components/travel-booking-progress-bar/data/travel.data';
import { ISiteSettingsSwitches } from '@shared/shared/interfaces/site-settings.interfaces';
import { ITravelBookingProgressBar } from '@shared/shared/interfaces/travel-booking-progress-bar.interfaces';
import { RouterStateUrl } from '@shared/store';
import { TravelSearchToggles } from '@shared/store/models/travel-search-toggles';
import * as UrlLib from '@shared/utils/url.lib';
import * as fromFeature from '../reducers/';
import { getTravelSearchTogglesFeatureState } from './travel-search-toggles.selectors';

const getRouterState = createFeatureSelector<RouterReducerState<RouterStateUrl>>('router');

export const GetTravelBookingBarState = createSelector(
  fromFeature.getTravelBookingState,
  (state: fromFeature.TravelBookingState) => state.travelBookingBar
);

export const GetTravelBookingBarSteps = createSelector(
  GetTravelBookingBarState,
  getTravelSearchTogglesFeatureState,
  getRouterState,
  (
    progressBarState: ITravelBookingProgressBar,
    toggles: TravelSearchToggles,
    routerState: any,
    switches: ISiteSettingsSwitches
  ) => {
    const progressBarSteps = [];

    if (toggles.flight && switches.travel_flights_module) {
      progressBarSteps.push(flightSteps);
    }

    if (toggles.hotel && switches.travel_hotels_module) {
      progressBarSteps.push(hotelSteps);
    }

    if (toggles.car && switches.travel_car_hire_module) {
      progressBarSteps.push(carSteps);
    }

    return progressBarSteps.map((step) => {
      const children = step.children.map((stepchild) => {
        const isComplete = progressBarState[isCompleteMap[stepchild.key] as keyof ITravelBookingProgressBar];
        const isCurrent = stepUrls[stepchild.key]?.some((url: string) => UrlLib.matchUrl(routerState.state.url, [url]));

        return {
          ...stepchild,
          isComplete,
          isCurrent,
        };
      });

      return {
        ...step,
        children,
        isComplete: children.every((child) => child.isComplete),
        isActive: children.some((child) => child.isCurrent),
      };
    });
  }
);
